import { useQuery } from '@tanstack/react-query';
import { getEosTodo } from '../api';
import { eosTodoKeys } from './useEosTodos';

export function useEosTodo(id: string | null) {
  return useQuery({
    queryKey: eosTodoKeys.detail(id || ''),
    queryFn: () => getEosTodo(id as string),
    enabled: !!id,
  });
}
